import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getStudentInfo, getStudentPhoto } from "../../store/studentSlice";
import {
  formatDateString,
  getCurrentDate,
  shortenName,
} from "../../assets/utils/functions";

import "./style.css";
import { getNotificationsStudent } from "../../store/notificationSlice";
import { useMediaQuery } from "react-responsive";
import { Pagination } from "../../components/Pagination";
import { Spinner } from "../../components/Spinner";
import { ErrorMessage } from "../../components/Error/ErrorMessage";

export const StudentProfile = () => {
  const userToken = useSelector((state) => state.auth.userToken);
  const userName = useSelector((state) =>
    state.student.studentInfo ? state.student.studentInfo.name : ""
  );
  const codeSpecialization = useSelector((state) =>
    state.student.studentInfo
      ? state.student.studentInfo.group.spec.specCode
      : ""
  );
  const specializationName = useSelector((state) =>
    state.student.studentInfo ? state.student.studentInfo.group.spec.name : ""
  );
  const groupName = useSelector((state) => state.student.studentGroup);
  const {
    studentNotifications,
    studentNotificationsStatus,
    studentNotificationsError,
  } = useSelector((state) => state.notification);

  const [sortedNotifications, setSortedNotifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const dispatch = useDispatch();
  const currentDate = getCurrentDate();

  const isMobile = useMediaQuery({ maxWidth: 520 });
  const numberOfRecords = isMobile ? 3 : 3;

  useEffect(() => {
    dispatch(getStudentInfo(userToken));
    // dispatch(getNotificationsStudent(userToken));
    // dispatch(getStudentPhoto(userToken));
  }, [userToken]);

  useEffect(() => {
    const sortedNotifications =
      sortNotificationsByCreated(studentNotifications);
    setSortedNotifications(sortedNotifications);
  }, [studentNotifications]);

  const sortNotificationsByCreated = (notifications) => {
    return notifications.slice().sort((a, b) => {
      const dateA = new Date(a.created);
      const dateB = new Date(b.created);

      return dateB - dateA;
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const lastRecordIndex = currentPage * numberOfRecords;
  const firstRecordIndex = lastRecordIndex - numberOfRecords;
  const currentRecords = sortedNotifications.slice(
    firstRecordIndex,
    lastRecordIndex
  );

  return (
    <>
      {studentNotificationsStatus === "loading" && (
        <Spinner type="points" text="Идёт загрузка" />
      )}
      {studentNotificationsError && (
        <ErrorMessage error={studentNotificationsError} />
      )}
      {studentNotificationsStatus !== "loading" &&
        !studentNotificationsError && (
          <div className="profile-container">
            <div className="student-info">
              <div className="student-info-header">
                <h2 className="student-name">Здравствуйте, {userName}!</h2>
                <div className="current-date">Сегодня - {currentDate}</div>
              </div>
              <div>
                <div className="student-info-row">
                  <span className="student-info-row-name">
                    Код специальности:
                  </span>
                  <span className="student-info-row-data">
                    {codeSpecialization}
                  </span>
                </div>
                <div className="student-info-row">
                  <span className="student-info-row-name">Название:</span>
                  <span className="student-info-row-data">
                    {specializationName}
                  </span>
                </div>
                <div className="student-info-row">
                  <span className="student-info-row-name">Группа:</span>
                  <span className="student-info-row-data">{groupName}</span>
                </div>
              </div>
            </div>
            <div className="notifications">
              <div className="notifications-header">
                <h3 className="notifications-title">Уведомления</h3>
                {/*<span className="see-all">Посмотреть все</span>*/}
              </div>
              {sortedNotifications.length === 0 ? (
                <div className="no-notifications">Уведомлений пока нет</div>
              ) : (
                <>
                  {currentRecords.map((item, index) => (
                    <div key={index} className="notification-block">
                      <h4 className="notification-title">
                        {item.teacherFIO}, {formatDateString(item.created)}
                      </h4>
                      <p>
                        <span className="notification-span">Тема:</span>
                        {item.topic}
                      </p>
                      <p className="notification-text">{item.msg}</p>
                    </div>
                  ))}
                  <div className="pagination-wrapper">
                    <Pagination
                      currentPage={currentPage}
                      numberOfRecords={numberOfRecords}
                      totalRecords={sortedNotifications.length}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        )}
    </>
  );
};
